<template>
  <div class="mt-4">
    <el-table
      ref="multipleTable"
      :data="segmentData"
      style="width: 100%"
      border
      @selection-change="handleSelectionChange"
      header-row-class-name="thead-light table-th-color"
    >
      <el-table-column type="selection" width="100"> </el-table-column>
      <el-table-column label="Name" width="250">
        <template slot-scope="scope">{{ scope.row.name }}</template>
      </el-table-column>
      <el-table-column :property="totalUsers" label="Total Users">
        <template slot-scope="scope">{{
          scope.row.audienceId.length
        }}</template>
      </el-table-column>
    </el-table>
    <div class="flex justify-end mt-4">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="
          (value) => {
            currentPage = value;
            getAllSegments();
          }
        "
        :per-size="perPage"
        :total="totalUsers"
      >
      </el-pagination>
    </div>
    <div class="flex mt-6 justify-end gap-3">
      <div class="relative">
        <vs-button
          variant="primary"
          class="rounded-lg bg-primary border-0 text-white font-medium fsize14 py-3 w-full sm-fsize14"
          @click="segmentAdd"
        >
          Submit
        </vs-button>
      </div>
      <div class="relative">
        <vs-button
          @click="cancelSegment"
          type="secondary"
          class="rounded-lg bg-secondary border-0 text-white font-medium fsize14 py-3 w-full sm-fsize14"
        >
          Cancel
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      multipleSelection: [],
      segmentData: [],
      handleCreateSegment: false,
      totalUsers: "0",
    };
  },

  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async getAllSegments(value) {
      try {
        let payload = {
          perPage: this.perPage,
          page: this.currentPage,
        };
        if (value) {
          Object.assign(payload, { name: value });
        }
        let data = await this.$store.dispatch("segment/getAllSegment", payload);
        this.segmentData = data.data.registeredUser;
        this.totalUsers = data.data.registeredUserLength;
        console.log(data);
      } catch (err) {
        console.log(err);
      }
    },
    segmentAdd() {
      this.$emit("segments", this.multipleSelection);
      this.$emit("handleCreateSegmentPopup");
      // this.$refs.multipleTable.clearSelection();
      // console.log(this.multipleSelection);
    },
    cancelSegment() {
      // this.segmentAdd();
      this.$emit("handleCreateSegmentPopup");
    },
  },
  async mounted() {
    this.getAllSegments();
    this.multipleSelection;
  },
};
</script>
